import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overall" }
const _hoisted_2 = { class: "second layer" }
const _hoisted_3 = { class: "card left" }

import VChart from "vue-echarts";
import { use } from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  GridComponent,
  TooltipComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OverallView',
  setup(__props) {

use([
  TitleComponent,
  GridComponent,
  TooltipComponent,
  LineChart,
  CanvasRenderer,
]);

// 模拟数据
const timeData = ref<string[]>([]);
const userData = ref<number[]>([]);
const getRandomArray = (init: number, range: number) => {
  const arr = [] as number[];
  arr.unshift(init);

  for (let i = 1; i < 30; i++) {
    const lastValue = arr[0]; // 获取最新的值
    const min = Math.max(0, lastValue - range); // 限制最小值，防止小于 0
    const max = Math.min(1000, lastValue + range); // 限制最大值，防止超过 1000
    const newValue = Math.floor(Math.random() * (max - min + 1)) + min; // 生成符合范围的随机数
    arr.unshift(newValue);
  }
  return arr;
};

const generateData = () => {
  for (let i = 1; i < 30; i++) {
    timeData.value.unshift(
      new Date(Date.now() - 1000 * 60 * 60 * 24 * i).toLocaleString()
    );
  }
  userData.value.splice(0, userData.value.length, ...getRandomArray(156, 5));
};

const option = ref({
  title: {
    text: "用户数",
    left: "1%",
  },
  xAxis: {
    data: timeData.value,
  },
  tooltip: {
    trigger: "axis",
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: userData.value,
      type: "line",
    },
  ],
});

onMounted(() => {
  generateData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"first layer\" data-v-489ba73a><div class=\"card\" data-v-489ba73a><div class=\"statistic-card\" data-v-489ba73a><p class=\"title\" data-v-489ba73a>总用户数</p><p class=\"value\" data-v-489ba73a>168 <span class=\"change increase\" data-v-489ba73a>+2</span></p><p class=\"tip\" data-v-489ba73a>使用客户端的用户数量</p></div><div class=\"statistic-card\" data-v-489ba73a><p class=\"title\" data-v-489ba73a>总船舶数</p><p class=\"value\" data-v-489ba73a>2158 <span class=\"change increase\" data-v-489ba73a>+5</span></p><p class=\"tip\" data-v-489ba73a>绑定云端的船舶数量</p></div><div class=\"statistic-card\" data-v-489ba73a><p class=\"title\" data-v-489ba73a>今日总里程数</p><p class=\"value\" data-v-489ba73a> 412,306 km <span class=\"change decrease\" data-v-489ba73a>-3%</span></p><p class=\"tip\" data-v-489ba73a>今日所有绑定云端船舶的总里程数</p></div><div class=\"statistic-card\" data-v-489ba73a><p class=\"title\" data-v-489ba73a>今日总减排</p><p class=\"value\" data-v-489ba73a> 15,302 m³ <span class=\"change increase\" data-v-489ba73a>+11%</span></p><p class=\"tip\" data-v-489ba73a>今日通过新能源船舶减排的二氧化碳</p></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(VChart), {
          class: "chart",
          option: option.value
        }, null, 8, ["option"])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card right" }, null, -1))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "third layer" }, [
      _createElementVNode("div", { class: "card left" }),
      _createElementVNode("div", { class: "card right" })
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"margin-top":"20px"} }, null, -1))
  ]))
}
}

})